// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UserRequestModel {
    static getAttributeTypeMap() {
        return UserRequestModel.attributeTypeMap;
    }
}
UserRequestModel.discriminator = undefined;
UserRequestModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "password",
        "baseName": "password",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "pictureUrl",
        "baseName": "pictureUrl",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "blocked",
        "baseName": "blocked",
        "type": "boolean"
    },
    {
        "name": "emailVerified",
        "baseName": "emailVerified",
        "type": "boolean"
    },
    {
        "name": "phoneVerified",
        "baseName": "phoneVerified",
        "type": "boolean"
    },
    {
        "name": "verifyEmail",
        "baseName": "verifyEmail",
        "type": "boolean"
    },
    {
        "name": "linkedAccount",
        "baseName": "linkedAccount",
        "type": "number"
    },
    {
        "name": "resetPasswordEmail",
        "baseName": "resetPasswordEmail",
        "type": "boolean"
    },
    {
        "name": "roles",
        "baseName": "roles",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=userRequestModel.js.map